import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout";

// ✅ Custom video background wrapper
function BackgroundWrapper({ children }) {
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Video Background */}
      <video
        className="fixed inset-0 z-0 w-full h-full object-cover"
        src="/assets/bg1.mp4"
        autoPlay
        muted
        loop
        playsInline
      />

      {/* Optional dark overlay for readability */}
      <div className="fixed inset-0 z-0 bg-black/60" />

      {/* Content wrapper */}
      <div className="relative z-10">{children}</div>
    </div>
  );
}

export default function Twitch() {
  const parent = typeof window !== "undefined" ? window.location.hostname : "chaotik.org";

  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: "https://chaotik.org/" },
      { "@type": "ListItem", position: 2, name: "Twitch", item: "https://chaotik.org/media/Twitch" },
    ],
  };

  const channelJsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "CHAOTIK",
      url: "https://chaotik.org/",
      sameAs: ["https://www.twitch.tv/chaotiksc"],
    },
    {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Qravey",
      url: "https://www.twitch.tv/qqrave",
      sameAs: ["https://www.twitch.tv/qqrave"],
      memberOf: { "@type": "Organization", name: "CHAOTIK", url: "https://chaotik.org/" },
    },
    {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Jetskier47",
      url: "https://www.twitch.tv/jetskier47",
      sameAs: ["https://www.twitch.tv/jetskier47"],
      memberOf: { "@type": "Organization", name: "CHAOTIK", url: "https://chaotik.org/" },
    },
  ];

  return (
    <BackgroundWrapper>
      <Layout>
        <Helmet>
          <title>CHAOTIK Twitch Streamers | Star Citizen Org</title>
          <meta
            name="description"
            content="Watch CHAOTIK members streaming Star Citizen on Twitch. Combat, industry, bounty hunting, cargo, exploration and tactical ops from a 24/7 multi-role EU/US/AUS org."
          />
          <link rel="canonical" href="https://chaotik.org/media/Twitch" />
          <meta property="og:title" content="CHAOTIK Twitch Streamers | Star Citizen Org" />
          <meta property="og:description" content="Watch CHAOTIK members streaming Star Citizen on Twitch." />
          <meta property="og:url" content="https://chaotik.org/media/Twitch" />
          <meta name="twitter:title" content="CHAOTIK Twitch Streamers" />
          <meta name="twitter:description" content="Watch CHAOTIK members streaming Star Citizen on Twitch." />
          <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
          {channelJsonLd.map((j, idx) => (
            <script key={idx} type="application/ld+json">{JSON.stringify(j)}</script>
          ))}
        </Helmet>
        <div className="flex flex-col items-center justify-center text-center px-4 py-10">
          <h1 className="text-white text-4xl sm:text-5xl font-bebas mb-10">CHAOTIK Twitch Streamers</h1>

          {/* Org Channel - CHAOTIK SC */}
          <div className="w-full max-w-7xl mb-16">
            <h2 className="text-white text-2xl sm:text-3xl md:text-4xl font-bebas mb-4">CHAOTIK SC</h2>
            <div className="flex flex-col lg:flex-row gap-6">
              <div className="flex-1 min-h-[420px] sm:min-h-[480px] rounded-xl border border-red-500/40 shadow-[0_0_25px_rgba(248,113,113,0.35)] overflow-hidden backdrop-blur-sm bg-black/40">
                <iframe
                  src={`https://player.twitch.tv/?channel=chaotiksc&parent=${parent}`}
                  height="480"
                  width="100%"
                  allowFullScreen
                  className="w-full h-full min-h-[420px] sm:min-h-[480px]"
                  title="CHAOTIK SC Stream"
                ></iframe>
              </div>

              <div className="rounded-xl min-h-[420px] sm:min-h-[480px] border border-red-500/40 shadow-[0_0_25px_rgba(248,113,113,0.35)] overflow-hidden backdrop-blur-sm bg-black/40 hidden lg:block lg:min-w-[350px]">
                <iframe
                  src={`https://www.twitch.tv/embed/chaotiksc/chat?parent=${parent}`}
                  height="480"
                  width="350"
                  className="w-full h-full min-h-[420px] sm:min-h-[480px]"
                  title="CHAOTIK SC Chat"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Streamer 1 - Qravey */}
          <div className="w-full max-w-7xl mb-16">
            <h2 className="text-white text-2xl sm:text-3xl md:text-4xl font-bebas mb-4">Qravey</h2>
            <div className="flex flex-col lg:flex-row gap-6">
              <div className="flex-1 min-h-[420px] sm:min-h-[480px] rounded-xl border border-red-500/40 shadow-[0_0_25px_rgba(248,113,113,0.35)] overflow-hidden backdrop-blur-sm bg-black/40">
                <iframe
                  src={`https://player.twitch.tv/?channel=qqrave&parent=${parent}`}
                  height="480"
                  width="100%"
                  allowFullScreen
                  className="w-full h-full min-h-[420px] sm:min-h-[480px]"
                  title="Qravey Stream"
                ></iframe>
              </div>

              <div className="rounded-xl min-h-[420px] sm:min-h-[480px] border border-red-500/40 shadow-[0_0_25px_rgba(248,113,113,0.35)] overflow-hidden backdrop-blur-sm bg-black/40 hidden lg:block lg:min-w-[350px]">
                <iframe
                  src={`https://www.twitch.tv/embed/qqrave/chat?parent=${parent}`}
                  height="480"
                  width="350"
                  className="w-full h-full min-h-[420px] sm:min-h-[480px]"
                  title="Qravey Chat"
                ></iframe>
              </div>
            </div>
          </div>
                    {/* Streamer 2 - Jetskier47 */}
          <div className="w-full max-w-7xl mb-16">
            <h2 className="text-white text-2xl sm:text-3xl md:text-4xl font-bebas mb-4">Jetskier47</h2>
            <div className="flex flex-col lg:flex-row gap-6">
              <div className="flex-1 min-h-[420px] sm:min-h-[480px] rounded-xl border border-red-500/40 shadow-[0_0_25px_rgba(248,113,113,0.35)] overflow-hidden backdrop-blur-sm bg-black/40">
                <iframe
                  src={`https://player.twitch.tv/?channel=jetskier47&parent=${parent}`}
                  height="480"
                  width="100%"
                  allowFullScreen
                  className="w-full h-full min-h-[420px] sm:min-h-[480px]"
                  title="Jetskier47 Stream"
                ></iframe>
              </div>

              <div className="rounded-xl min-h-[420px] sm:min-h-[480px] border border-red-500/40 shadow-[0_0_25px_rgba(248,113,113,0.35)] overflow-hidden backdrop-blur-sm bg-black/40 hidden lg:block lg:min-w-[350px]">
                <iframe
                  src={`https://www.twitch.tv/embed/jetskier47/chat?parent=${parent}`}
                  height="480"
                  width="350"
                  className="w-full h-full min-h-[420px] sm:min-h-[480px]"
                  title="Jetskier47 Chat"
                ></iframe>
              </div>
            </div>
          </div>

        </div>
      </Layout>
    </BackgroundWrapper>
  );
}
